import React, { useState, useEffect } from "react";
import { Badge, Drawer, IconButton, List } from "@material-ui/core";
import {
  Home as HomeIcon,
  Settings,
  Person,
  Room,
  CalendarToday,
  ArrowBack as ArrowBackIcon,
  School,
  AccountBalance,
  LocalActivity as Events,
  Archive,
  MenuBook,
  ListAlt,
  Label,
  PeopleAlt,
  ContactPhone,
  PhoneDisabled,
  Block,
  Dashboard,
  LocalOffer,
  Phone,
  Notifications,
  Restore,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter, useParams } from "react-router-dom";
import classNames from "classnames";
import Cookies from "universal-cookie";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import getNotifiche from "../../services/getNotifiche";
import getLeadsCount from "../../services/getLeadsCount";
import { useNotifications } from "../../context/NotificationContext";
import { useLeads } from "../../context/LeadsContext";

function getIconFromType(type) {
  return <HomeIcon />;
}

function Sidebar({ location, ...props }) {
  var classes = useStyles();
  var theme = useTheme();
  const { notificheCount, updateNotificheCount } = useNotifications();
  const { leadsCount, updateLeadsCount } = useLeads();

  //var props = useParams();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  //let menuItems = JSON.parse(props);

  let jsonItems = [];
  try {
    jsonItems = props.menuItems;
  } catch (error) {}

  const cookies = new Cookies();
  const username = cookies.get("username", { path: "/" });
  const token = cookies.get("token", { path: "/" });
  const userType = cookies.get("userType", { path: "/" });
  const brokerType = cookies.get("brokerType", { path: "/" });
  const userId = cookies.get("userId", { path: "/" });

  useEffect(() => {
    const pollNotifiche = () => {
      getNotifiche(username, token, userId).then((resp) => {
        if (resp && resp.length > 0) {
          let unreadCount = 0;
          for (let i = 0; i < resp.length; i++) {
            if (resp[i].read === 0) unreadCount++;
          }
          updateNotificheCount(unreadCount);
        } else {
          console.log("Errore nel recupero delle notifiche");
        }
      });
    };

    pollNotifiche();
    const intervalId = setInterval(pollNotifiche, 50000);
    return () => clearInterval(intervalId);
  }, [username, token, userId, updateNotificheCount]);

  // Polling per i leads non visti
  useEffect(() => {
    const pollLeads = () => {
      getLeadsCount(username, token).then((resp) => {
        if (resp && resp.success) {
          updateLeadsCount(resp.count);
        }
      });
    };

    pollLeads();
    const intervalId = setInterval(pollLeads, 60000); // ogni 60 secondi
    return () => clearInterval(intervalId);
  }, [username, token, updateLeadsCount]);

  let structure = [];

  if (userType == 4) {
    structure = [
      // Nascondiamo la voce Dashboard per l'operatore phoneop
      ...(username === "phoneop"
        ? []
        : [
            {
              id: 23,
              label: "Dashboard",
              link: "/app/dashboard",
              icon: <Dashboard />,
            },
          ]),
      {
        id: 1,
        label: "Da Chiamare",
        link: "/app/dachiamare",
        icon: (
          <Badge badgeContent={leadsCount} color="secondary">
            <ContactPhone />
          </Badge>
        ),
      },
      {
        id: 2,
        label: "Chiamati",
        link: "/app/chiamati",
        icon: <PhoneDisabled />,
      },
      { id: 14, label: "Tag", link: "/app/tag", icon: <Label /> },
      { id: 9, type: "divider" },
      {
        id: 12,
        label: "Impostazioni",
        link: "/app/usersettings",
        icon: <Settings />,
      },
    ];
  } else {
    structure = [
      { id: 1, label: "Corsi", link: "/app/corsi", icon: <CalendarToday /> },
      { id: 3, label: "Studenti", link: "/app/studenti", icon: <Person /> },
      {
        id: 22,
        label: "Notifiche",
        link: "/app/notifiche",
        icon: (
          <Badge badgeContent={notificheCount} color="secondary">
            <Notifications />
          </Badge>
        ),
      },
      { id: 8, label: "Eventi", link: "/app/eventi", icon: <Events /> },
      { id: 23, label: "Recuperi", link: "/app/recuperi", icon: <Restore /> },
      // { id: 9, label: "Sconti", link: "/app/sconti", icon: <LocalOffer /> },
      {
        id: 10,
        label: "Scuola",
        link: "/app/scuola",
        icon: <AccountBalance />,
      },
      { id: 11, type: "divider" },
      {
        id: 12,
        label: "Dashboard",
        link: "/app/dashboard",
        icon: <Dashboard />,
      },
      {
        id: 13,
        label: "Leads",
        link: "/app/leads",
        icon: (
          <Badge badgeContent={leadsCount} color="secondary">
            <PeopleAlt />
          </Badge>
        ),
      },
      { id: 14, label: "Tag", link: "/app/tag", icon: <Label /> },
      { id: 15, type: "divider" },
      // { id: 12, label: "Sezione Billing", link: "/billing/corsi", icon: <Euro /> },
      {
        id: 16,
        label: "Archivio corsi",
        link: "/app/cestinoCorsi",
        icon: <Archive />,
      },
      {
        id: 17,
        label: "Impostazioni",
        link: "/app/usersettings",
        icon: <Settings />,
      },
    ];
  }

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
      style={{ position: "sticky" }}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        <img
          src={require("../../images/loghi/bianco_trasparente.png")}
          style={{
            position: "relative",
            width: "90%",
            marginBottom: "20px",
            marginTop: "20px",
            left: "5%",
          }}
        />
        {structure.map((link) => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
